module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_2.f969df34.jpg";